module.exports = __webpack_public_path__ + "img/客户预开户操作手册3800.7bfc00ae.png";